module.exports = __webpack_public_path__ + "static/media/huizhang.8e1748d5.svg";